import type { ReactNode } from 'react';
import styles from './page-title.module.css';

/**
 * A top-level page's title in the topbar head: the serif display title every
 * page head wears (docs/DESIGN_SYSTEM.md). One rule, so a page head cannot
 * drift to a local copy in another face (the Tags and Search heads did).
 *
 * `as="div"` draws the same face without a heading: the shell's loading
 * chrome shows the route's title before the page's own `h1` arrives
 * (src/components/loading-chrome-ui.tsx), and the page keeps the one heading.
 *
 * `truncate` keeps the title on one line and ellipsizes it: for a head whose
 * title is a name a person wrote (a lens, a list), which can outrun the top
 * bar's one row. In a flex head it can shrink below its text's width.
 */
export function PageTitle({
  children,
  testId,
  as: Tag = 'h1',
  truncate = false,
}: {
  children: ReactNode;
  testId?: string;
  as?: 'h1' | 'div';
  truncate?: boolean;
}) {
  return (
    <Tag
      className={truncate ? `${styles.title} ${styles.truncate}` : styles.title}
      data-testid={testId}
    >
      {children}
    </Tag>
  );
}
